package com.dotdrives.web.pages.updates

import com.dotdrives.controller.NewReportController
import com.dotdrives.controller.NewReportUiState
import com.dotdrives.model.ReportDefaultUpdate
import com.dotdrives.model.Target
import com.dotdrives.web.ui.DotBanner
import react.FC
import react.Key
import react.Props
import react.dom.aria.AriaRole
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.select
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.textarea
import web.cssom.ClassName
import web.html.ButtonType
import web.html.InputType
import web.html.button as buttonType
import web.html.text

external interface NewUpdateDialogProps : Props {
    var state: NewReportUiState
    var controller: NewReportController
    var targets: List<Target>
    var defaultUpdates: List<ReportDefaultUpdate>
    var onClose: () -> Unit
}

val NewUpdateDialog = FC<NewUpdateDialogProps> { props ->
    val state = props.state

    div {
        className = ClassName("updates-dialog-backdrop")
        role = "presentation".unsafeCast<AriaRole>()
        onClick = { props.onClose() }

        div {
            className = ClassName("updates-dialog")
            role = "dialog".unsafeCast<AriaRole>()
            ariaModal = true
            ariaLabel = "New giver update"
            onClick = { it.stopPropagation() }

            div {
                className = ClassName("updates-dialog-head")
                div { className = ClassName("updates-dialog-title"); +"New giver update" }
                button {
                    type = ButtonType.buttonType
                    className = ClassName("updates-dialog-close")
                    ariaLabel = "Close"
                    onClick = { props.onClose() }
                    +"✕"
                }
            }

            state.error?.let { error -> DotBanner { message = error; className = "updates-inline-banner" } }

            div {
                className = ClassName("updates-form-grid")
                div {
                    className = ClassName("updates-form-field")
                    span { className = ClassName("updates-form-label"); +"Report thread" }
                    select {
                        className = ClassName("updates-form-select")
                        ariaLabel = "Target"
                        value = state.targetId ?: ""
                        onChange = { props.controller.setTargetId(it.currentTarget.value.ifBlank { null }) }
                        option { value = ""; +"No specific target" }
                        props.targets.forEach { target ->
                            option { key = target.id.unsafeCast<Key>(); value = target.id; +target.name }
                        }
                    }
                }
                div {
                    className = ClassName("updates-form-field")
                    span { className = ClassName("updates-form-label"); +"Template" }
                    select {
                        className = ClassName("updates-form-select")
                        ariaLabel = "Template"
                        value = state.templateId ?: ""
                        onChange = { event ->
                            val selected = props.defaultUpdates.firstOrNull { it.id == event.currentTarget.value }
                            props.controller.setTemplate(selected)
                        }
                        option { value = ""; +"No template" }
                        props.defaultUpdates.forEach { template ->
                            option { key = template.id.unsafeCast<Key>(); value = template.id; +template.subject }
                        }
                    }
                }
            }

            div {
                className = ClassName("updates-form-field")
                style = js("({marginBottom: '10px'})")
                span { className = ClassName("updates-form-label"); +"Title" }
                input {
                    className = ClassName("updates-form-select")
                    type = InputType.text
                    value = state.title
                    placeholder = "October progress — pump house begins"
                    ariaLabel = "Update title"
                    onChange = { props.controller.setTitle(it.currentTarget.value) }
                }
            }

            textarea {
                className = ClassName("updates-form-textarea")
                value = state.body
                placeholder = "What happened?"
                ariaLabel = "Update body"
                onChange = { props.controller.setBody(it.currentTarget.value) }
            }

            div {
                className = ClassName("updates-dialog-actions")
                button {
                    type = ButtonType.buttonType
                    className = ClassName("dot-button dot-button-secondary")
                    disabled = state.saving
                    onClick = { props.controller.saveDraft() }
                    +"Save draft"
                }
                button {
                    type = ButtonType.buttonType
                    className = ClassName("dot-button dot-button-primary")
                    disabled = state.saving
                    onClick = { props.controller.submitForReview() }
                    +"Submit for review"
                }
            }
        }
    }
}
